import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import ConfigManager from '../../vendor_core/core/src/managers/ConfigManager';
import IBuyFeatureConfig from '../../vendor_core/core/src/managers/contracts/configurations/IBuyFeatureConfig';
import BetModel from '../../vendor_core/core/src/model/BetModel';

class BuyFeatureConfig implements IBuyFeatureConfig {
    type: ConfigurationTypes = ConfigurationTypes.BUY_FEATURE;
    betMultiplier = 100;
    betOptions = [];
    public getBetOptions() {
        let result = [];
        if (this.betOptions.length > 0) {
            this.betOptions.forEach(bet => {
                if (BetModel.creditValues.includes(bet)) {
                    result.push(bet)
                }
            })
        } else {
            result = ConfigManager.getConfig(ConfigurationTypes.BET).getBetOptions();
        }

        return result
    };
}

export default new BuyFeatureConfig()
